export const CLASE_CHANGED = 'CLASE_CHANGED';
export const CLASE_CLEAR = 'CLASE_CLEAR';

export const cacheClaseChanged = (nombreClase, datos) => {
    return {
        type: CLASE_CHANGED,
        clase: {nombreClase: nombreClase, datos: datos}
    }
}

export const cacheClaseClear= (nombreClase) => {
    return {
        type: CLASE_CLEAR,
        clase: {nombreClase: nombreClase}
    }
}